import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Loading from '../Loading'
import t from 'tcomb-form'
import { getForm } from '../../lib/FormUtils'
import payment from 'payment'

const {schema, options} = getForm({
  name: {type: 'string', required: true},
  number: {
    type: 'string',
    required: true,
    attrs: {
      className: 'cc-number',
      autocompletetype: 'cc-number'
    }
  },
  exp: {
    type: 'string',
    required: true,
    config: {size: 1, max: 2},
    label: 'EXP',
    attrs: {
      className: 'cc-exp',
      placeholder: 'MM / YY',
      autocompletetype: 'cc-exp'
    }
  },
  cvc: {
    type: 'string',
    required: true,
    config: {size: 1, max: 2},
    label: 'CVC',
    attrs: {
      className: 'cc-cvc',
      autoComplete: 'off',
      autocompletetype: 'cc-csc'
    }
  },
  address_zip: {
    type: 'string',
    label: 'Zip code',
    required: true
  }
})

export default class ChangePlan extends Component {
  static propTypes = {
    info: PropTypes.object,
    onSubmit: PropTypes.func,
    onCancel: PropTypes.func
  }

  state = {
    value: {},
    loading: false,
    error: ''
  }

  onChange = (value) => {
    this.setState({value})
  }

  onSubmit = async (e) => {
    e.preventDefault()

    this.setState({loading: true})
    try {
      await this.props.onSubmit(this.state.value)
    } catch (err) {
      this.setState({error: err.error.message})
    }

    this.setState({loading: false})
  }

  componentDidMount () {
    payment.formatCardNumber(document.querySelector('.cc-number'))
    payment.formatCardExpiry(document.querySelector('.cc-exp'))
    payment.formatCardCVC(document.querySelector('.cc-cvc'))
  }

  render () {
    const {value, loading, error} = this.state
    const {onCancel} = this.props

    return <form onSubmit={this.onSubmit} className='change-payment' autoComplete='on'>
      <t.form.Form type={schema} options={options} value={value} onChange={this.onChange} />
      <div className='buttons'>
        {loading && <Loading type='block' />}
        {!!error && <div className='error'>{error}</div>}
        <button className='btn btn-save' type='submit' disabled={loading}>Save</button>
        {onCancel &&
          <button className='btn btn-cancel' type='button' onClick={onCancel}>Cancel</button>
        }
      </div>
    </form>
  }
}



// WEBPACK FOOTER //
// ./app/components/account/ChangePayment.js